// Questions Types
export const QUESTIONS_FETCH_REQUEST = "QUESTIONS_FETCH_REQUEST";
export const QUESTIONS_FETCH_SUCCESS = "QUESTIONS_FETCH_SUCCESS";
export const QUESTIONS_FETCH_FAILURE = "QUESTIONS_FETCH_FAILURE";

export const QUESTION_CREATE_REQUEST = "QUESTION_CREATE_REQUEST";
export const QUESTION_CREATE_SUCCESS = "QUESTION_CREATE_SUCCESS";
export const QUESTION_CREATE_FAILURE = "QUESTION_CREATE_FAILURE";

export const QUESTION_UPDATE_REQUEST = "QUESTION_UPDATE_REQUEST";
export const QUESTION_UPDATE_SUCCESS = "QUESTION_UPDATE_SUCCESS";
export const QUESTION_UPDATE_FAILURE = "QUESTION_UPDATE_FAILURE";

export const QUESTION_DELETE_REQUEST = "QUESTION_DELETE_REQUEST";
export const QUESTION_DELETE_SUCCESS = "QUESTION_DELETE_SUCCESS";
export const QUESTION_DELETE_FAILURE = "QUESTION_DELETE_FAILURE";

export const QUESTION_FETCH_BY_ID_REQUEST = "QUESTION_FETCH_BY_ID_REQUEST";
export const QUESTION_FETCH_BY_ID_SUCCESS = "QUESTION_FETCH_BY_ID_SUCCESS";
export const QUESTION_FETCH_BY_ID_FAILURE = "QUESTION_FETCH_BY_ID_FAILURE";

// Reset
export const QUESTIONS_RESET = "QUESTIONS_RESET";
